// Layouts
export { default as RestaurantLayout } from './layouts/RestaurantLayout.vue';
export { default as RestaurantLayoutBase } from './layouts/RestaurantLayoutBase.vue';
// UI Components
export { default as ProductConfigModal } from './components/ProductConfigModal.vue';
export { default as ProductConfigModalBase } from './components/productConfig/ConfigModalBase.vue';
export { default as ProductConfigContent } from './components/productConfig/ConfigContent.vue';
export { default as CartComponentBase } from './components/cart/CartComponentBase.vue';
export { default as Cart } from './components/Cart.vue';
export { default as CheckoutRightSidebarBase } from './components/checkout/CheckoutRightSidebarBase.vue';
// ✅ Root Components (Round 3)
export { default as LazyImage } from './components/LazyImage.vue';
export { default as Footer } from './components/Footer.vue';
export { default as CookieConsentComponent } from './components/CookieConsent.vue';
export { default as CookieBanner } from './components/CookieBanner.vue';
export { default as GoogleReviews } from './components/GoogleReviews.vue';
export { default as InstagramFeed } from './components/InstagramFeed.vue';
export { default as ProductSlider } from './components/ProductSlider.vue';
export { default as OpeningHours } from './components/OpeningHours.vue';
export { default as ProjectLocationMap } from './components/ProjectLocationMap.vue';
export { default as DeliveryStatusBadge } from './components/DeliveryStatusBadge.vue';
export { default as CategoryHighlights } from './components/CategoryHighlights.vue';
export { default as CategoryIcon } from './components/CategoryIcon.vue';
export { CATEGORY_ICONS, CATEGORY_ICON_ASSETS, CATEGORY_ICON_SVGS, DEFAULT_CATEGORY_ICON_ID, resolveCategoryIconId, getCategoryIconAsset, getCategoryIconSvg, isLegacyFontAwesomeIcon, } from './config/categoryIconRegistry';
export { useCategoryIconStyles } from './composables/useCategoryIconStyles';
export { default as AboutUsSection } from './components/AboutUsSection.vue';
// ✅ Homepage Components (Round 3) - REMOVED: Too project-specific
// Projects should have their own HeroComponent and FeaturesComponent
export { useProductSearch } from './composables/useProductSearch';
// ✅ Misc Components (Round 4)
export { default as Content } from './components/Content.vue';
export { default as CartComponent } from './components/CartComponent.vue';
// ✅ Views (Round 4)
export { default as NotFoundPage } from './views/NotFoundPage.vue';
export { default as OrderSuccessPage } from './views/OrderSuccessPage.vue';
// ✅ Views (Round 9)
export { default as OrderStatusPage } from './views/OrderStatusPage.vue';
export { default as ImpressumPage } from './views/ImpressumPage.vue';
export { default as CheckoutPage } from './views/CheckoutPage.vue';
export { default as ProductDetailsPage } from './views/ProductDetailsPage.vue';
export { default as ProductListingPage } from './views/ProductListingPage.vue';
export { default as MenuPdfPage } from './views/MenuPdfPage.vue';
// ✅ Checkout Components (Round 1)
export { default as DiscountCodeInput } from './components/checkout/DiscountCodeInput.vue';
export { default as OrderTypeSelection } from './components/checkout/OrderTypeSelection.vue';
export { default as CustomerDataForm } from './components/checkout/CustomerDataForm.vue';
export { default as DeliveryAddressForm } from './components/checkout/DeliveryAddressForm.vue';
export { default as TimeSelectionForm } from './components/checkout/TimeSelectionForm.vue';
export { default as DynamicPaymentMethodSelection } from './components/checkout/DynamicPaymentMethodSelection.vue';
export { default as EnhancedOrderSubmitButton } from './components/checkout/EnhancedOrderSubmitButton.vue';
// ✅ Checkout Components (Round 2)
export { default as PayPalCheckout } from './components/checkout/PayPalCheckout.vue';
export { default as StripeCheckout } from './components/checkout/StripeCheckout.vue';
export { default as PaymentMethodSelection } from './components/checkout/PaymentMethodSelection.vue';
export { default as OrderSubmitButton } from './components/checkout/OrderSubmitButton.vue';
export { default as TimeSelectionModal } from './components/checkout/TimeSelectionModal.vue';
export { default as TimeSelectionModalStore } from './components/checkout/TimeSelectionModalStore.vue';
export { default as ContactDataModal } from './components/checkout/ContactDataModal.vue';
export { default as DualRangeSlider } from './components/checkout/DualRangeSlider.vue';
export { default as SingleRangeSlider } from './components/checkout/SingleRangeSlider.vue';
export { default as SingleTimeSlider } from './components/checkout/SingleTimeSlider.vue';
export { default as TimeRangeSlider } from './components/checkout/TimeRangeSlider.vue';
export { default as AdminRangeSlider } from './components/checkout/AdminRangeSlider.vue';
export { default as OrderOverview } from './components/checkout/OrderOverview.vue';
export { default as CheckoutRightSidebar } from './components/checkout/CheckoutRightSidebar.vue';
export { default as DeliveryAddressModal } from './components/checkout/DeliveryAddressModal.vue';
// ✅ Order Components (Round 9)
export { default as OrderProgressTimeline } from './components/order/OrderProgressTimeline.vue';
// Services
export { RestaurantApiClient } from './services/RestaurantApiClient';
// Enhanced Composables
export { useApi, groupProductsByCategory, getCategoryIcon } from './composables/useApi';
export { useMenu } from './composables/useMenu';
export { useMenus } from './composables/useMenus';
export { default as MenuCard } from './components/menu/MenuCard.vue';
export { default as CartMenuLine } from './components/menu/CartMenuLine.vue';
export { default as MenusSection } from './components/menu/MenusSection.vue';
export { default as MenuConfigWizard } from './components/menu/MenuConfigWizard.vue';
export { useOrders } from './composables/useOrders';
export { useOrderPricing } from './composables/useOrderPricing';
export { useOrderCreation } from './composables/useOrderCreation';
export { useServiceFee } from './composables/useServiceFee';
export { useGooglePlaces } from './composables/useGooglePlaces';
export { useCheckoutWithDeliveryZones } from './composables/useCheckoutWithDeliveryZones';
export { useCheckoutWithZones } from './composables/useCheckoutWithZones';
export { useDeliveryZoneValidation } from './composables/useDeliveryZoneValidation';
export { useStructuredData } from './composables/useStructuredData';
export { useSpecialDeals } from './composables/useSpecialDeals';
export { useProjectConfig, PROJECT_CONFIG_KEY, injectStructuredData, updateMetaTags } from './composables/useProjectConfig';
export { useProductCardStyles, defaultCardStyles as defaultProductCardStyles } from './composables/useProductCardStyles';
export { useGoogleReviews } from './composables/useGoogleReviews';
export { useInstagramFeed } from './composables/useInstagramFeed';
// ✅ Pinia Stores
export { useProductPricingStore } from './stores/useProductPricingStore';
export { useCartStore } from './composables/useCartStore';
export { useCheckoutStore } from './stores/checkout-store';
// Cookie Management
export { useCookieManager, createCookieManager, cookieManager } from './composables/useCookieManager';
// Theme Management
export { useTheme } from './composables/useTheme';
// Runtime Site Config (Template-basierte Projekte / demo.<domain>/<slug>)
export { useSiteConfig, loadSiteConfig, getRuntimeBasePath, isDemoHost, getDemoSlugFromPath } from './composables/useSiteConfig';
// Utils
export { applyProjectFavicon, buildLetterFaviconDataUrl, getProjectInitial, resolveProjectFaviconUrl } from './utils/projectFavicon';
export { applyPageSeo, buildDefaultSeoTitle, resolvePageTitle, resolvePageDescription, resolveCanonicalUrl } from './utils/pageSeo';
export { useStarterStructuredData } from './composables/useStarterStructuredData';
export { buildStructuredDataGraph, buildRestaurantSchema, buildWebSiteSchema, buildMenuSchema, injectStructuredDataIntoHtml, serializeStructuredDataScripts } from './utils/projectStructuredData';
export { MoneyUtils } from './utils/MoneyUtils';
export { debugProductData, debugIngredientCategories, validateModalData } from './utils/modalDebug';
export * from './utils/environment';
export * from './utils/imageOptimization';
export * from './utils/performance';
export * from './utils/csp';
export { slugifySegment, generateProductSlug, getProductSlugCandidates, getCategorySlugFromProduct } from './utils/productSlug';
export { needsProductConfiguration } from './utils/productConfiguration';
export { cartItemToOrderRequest, generateCartConfigId, validateCart } from './types/cart';
import { RestaurantApiClient } from './services/RestaurantApiClient';
export const RestaurantPlugin = {
    install(app, options) {
        console.log('🔌 Installing RestaurantPlugin with options:', options);
        // Create API client instance
        const apiClient = new RestaurantApiClient({
            name: options.name,
            apiBaseUrl: options.apiBaseUrl,
            publicApiBaseUrl: options.publicApiBaseUrl,
            projectIdentifier: options.projectIdentifier,
            customHeaders: options.customHeaders,
            theme: options.theme
        });
        console.log('🔧 API Client created:', apiClient);
        // Provide project context, API client AND project config globally
        app.provide('projectContext', options.context);
        app.provide('apiClient', apiClient);
        app.provide('projectConfig', options); // ✅ NEW: Provide full config for useTheme
        console.log('✅ RestaurantPlugin installed successfully');
        console.log('🔑 Provided keys: projectContext, apiClient, projectConfig');
        // Global properties (optional)
        app.config.globalProperties.$api = apiClient;
        app.config.globalProperties.$projectContext = options.context;
    }
};
// Default configurations for common use cases
export const createRestaurantConfig = (overrides) => {
    // ✅ Use environment variable for consistent API configuration
    const baseUrl = process.env.API_BASE_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3010/api');
    const publicBaseUrl = baseUrl.replace('/api', '/public');
    return {
        name: 'Restaurant App',
        apiBaseUrl: baseUrl,
        publicApiBaseUrl: publicBaseUrl,
        projectIdentifier: 'restaurant.app',
        context: {
            name: 'Restaurant',
            description: 'Premium dining experience',
            navigation: [
                { name: 'Home', path: '/', icon: 'home' },
                { name: 'Menu', path: '/menu', icon: 'menu' },
                { name: 'About', path: '/about', icon: 'info' },
                { name: 'Contact', path: '/contact', icon: 'phone' }
            ],
            ctaText: 'Book Table',
            contactInfo: {
                address: '123 Restaurant St, City',
                phone: '+49 123 456 789',
                email: 'info@restaurant.com'
            }
        },
        ...overrides
    };
};
// Export styles
export const styles = {
    main: './styles/main.css'
};
